import "../css/civil.css";

export default function Civil() {
    return (
        <div>
            <h1>Mariage civil ce mercredi 20 mai</h1>
            <p>Tout d'abord, nous tenons à remercier toutes les personnes présentes durant la cérémonie et la fête de mariage.</p>
            {/* <p>Voici les informations concernant le mariage civil</p> */}

            <div className="info-container">
                <img width='300' src="images/civil.jpg" alt="Sam & Nina" className="info-photo" />
                {/* <h2>Date </h2> */}
                <p>Le mariage civil commencera à 15h30, nous vous donnons rendez-vous à 14h à la maison ou à 15h15 devant l'administration communale.</p>
                <h2>Lieu : Maison communale de Sambreville<br />
                    Grand'Place 1, 5060 Sambreville</h2>
                <h2>Et après ?</h2>
                <p> Rendez-vous à la maison <br />
                    136 Rue de Falisolle, 5060 Auvelais
                </p>
                {/* <p>Bienvenue qui veut, on poussera les murs au besoin.</p> */}
                <p>En mode auberge espagnole (n'oubliez pas d'apporter des Tupperwares car nos frigos débordent), bienvenue qui veut, on poussera les murs au besoin.</p>
                <p>N'hésitez pas à appeler Sam  si vous avez des questions</p>
            </div>

            <h2>Souvenirs</h2>

            <p className="souvenir">Vous pouvez retrouver les photos du mariage sur la <a href="/galerie" className='btn btn-validate'>galerie</a>.</p>
            <iframe id="diaporama" title="diaporama" src="/diaporama.html" ></iframe>
{/* style="    width: 100%;    height: 500px;    border: none;    border-radius: 12px;    overflow: hidden;  " */}
            <p>N'hésitez pas également à <a href="/upload" className='btn btn-validate'>envoyer vos photos et vidéos</a></p>

        </div>
    );
}

